import arrowIcon from "../../icons/arrow-dark.png";
import "../../scss/ServicesSection.scss";
import { useMobile } from "../../hooks/useMobile";
import forward from "../../icons/forward.png";
import print from "../../images/long-live-long.png";

export default function ServicesSection() {
  const isMobile = useMobile();

  // данные услуг (переиспользуем для двух версий)
  const services = [
    {
      title: "Интернет-магазины",
      link: "/online-stores",
      desc: "Функциональные, быстрые, визуально безупречные решения под любой уровень бизнеса — от бутика до экосистемы.",
      points: [
        "Архитектура, повышающая конверсию и скорость покупки",
        "Гибкие CMS и интеграции с 1С, CRM, аналитикой",
        "Дизайн, формирующий ощущение бренда, а не шаблона",
      ],
    },
    {
      title: "Лендинги под ключ",
      link: "/landings",
      desc: "Одностраничные сайты, которые фокусируют внимание, собирают статистику и ведут аудиторию к необходимому действию",
      points: [
        "Разрабатываем лендинги под любой запрос — от идеи до публикации",
        "Построенные на логике продаж структура, тексты и визуал",
        "Современный дизайн, высокая скорость и качественный адаптив",
      ],
    },
    {
      title: "Корпоративные сайты",
      link: "/corporative-sites",
      desc: "Цифровое лицо компании, создающее правильное впечатление и формирующее доверие к бренду.",
      points: [
        "Создаём корпоративные сайты под ключ — мы снимем с вас все заботы",
        "Проектируем архитектуру, отражающую характер и цели компании",
        "Упор на эстетику, скорость и стабильную работу под нагрузкой",
      ],
    },
    {
      title: "Интернет-маркетинг",
      link: "/marketing",
      desc: "Контекст, таргет, SEO, аналитика. Чистая структура кампаний и измеримый результат без хаоса.",
      points: [
        "Комплексная настройка и ведение Яндекс.Директ, VK Ads",
        "Сквозная аналитика и еженедельная отчётность",
        "Оптимизация под результат: заявки, ROI, удержание",
      ],
    },
    {
      title: "UI/UX-дизайн и брендинг",
      link: "/design",
      desc: "Разрабатываем дизайн-системы, интерфейсы и айдентику, где каждая деталь подчинена логике и стилю.",
      points: [
        "Исследования и прототипы на основе сценариев пользователя",
        "Чистый визуал, интуитивная навигация, ощущение статуса",
        "Полный бренд-гайд и визуальная стратегия",
      ],
    },
    {
      title: "Мобильные приложения",
      link: "#contact",
      desc: "Разрабатываем приложения, где технология служит идее, а интерфейс становится продолжением бренда.",
      points: [
        "Проектируем интерфейс под реальные сценарии пользователя",
        "Разрабатываем архитектуру с прицелом на рост и интеграции",
        "Создаём визуальный язык, работающий на узнаваемость и комфорт",
      ],
    },
  ];

  return (
    <section className="services" id="services">
      {isMobile ? (
        /* 📱 МОБИЛЬНАЯ ВЕРСИЯ */
        <div className="services-mobile">
          <h2 className="services-mobile__title">ОСНОВНЫЕ УСЛУГИ</h2>

          <div className="services-mobile__list">
            {services.map((s, i) => (
              <a href={s.link} className="services-mobile__item" key={i}>
                <h3 className="services-mobile__item-title">{s.title}</h3>
                <p className="services-mobile__item-desc">{s.desc}</p>

                <ul className="services-mobile__item-list">
                  {s.points.map((p, j) => (
                    <li key={j}>{p}</li>
                  ))}
                </ul>
                <div className="services-mobile__forward">
                  <button className="services-mobile__btn">Перейти</button>
                  <img
                    src={forward}
                    className="forward-arrow"
                    style={{ width: "30px", height: "7px" }}
                  />
                </div>
              </a>
            ))}
          </div>

          <button
            className="services-mobile__all"
            onClick={() => {
              window.dispatchEvent(new Event("open-mobile-menu"));
            }}
          >
            изучить все услуги
          </button>

          <div className="services-mobile__footer">
            <div className="services-mobile__square"></div>
            <div>
              <h3>ЧЕМ МЫ ВАМ ПОМОЖЕМ?</h3>
              <p>3. Мы реализуем любой цифровой запрос</p>
            </div>
          </div>
        </div>
      ) : (
        /* 🖥 ДЕСКТОПНАЯ ВЕРСИЯ — твоя оригинальная */
        <div className="services__container">
          <div className="services__left">
            <h2 className="services__title">ОСНОВНЫЕ УСЛУГИ</h2>
            <img
              src={print}
              style={{ width: "172px", height: "172px", marginBottom: "134px" }}
            />
            <a href="#" className="services__link">
              <span>изучить все услуги</span>
              <img src={arrowIcon} alt="arrow" className="services__arrow" />
            </a>

            <div className="services__footer">
              <div className="services__square"></div>
              <div>
                <h3 className="services__footer-title">ЧЕМ МЫ ВАМ ПОМОЖЕМ?</h3>
                <p className="services__footer-text">
                  3. Мы реализуем любой цифровой запрос
                </p>
              </div>
            </div>
          </div>

          <div className="services__right">
            {services.map((s, i) => (
              <a href={s.link} className="services__item" key={i}>
                <div className="services__item-header">
                  <h4 className="services__item-title">{s.title}</h4>
                  <p className="services__item-desc">{s.desc}</p>
                </div>
                <ul className="services__item-list">
                  {s.points.map((p, j) => (
                    <li key={j}>{p}</li>
                  ))}
                </ul>
              </a>
            ))}
          </div>
        </div>
      )}
    </section>
  );
}
